import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TextareaAutosize from "react-textarea-autosize";
import Header from "../components/Header.jsx";
import Loader from "../components/Loader";
import { fetchStateProcurements, updateStateProcurement } from "../services/stateProcurementService";
import "../styles/pages/state-procurement_page.css";
import "../styles/components/form.css";

const StateProcurementPage = () => {
    const [procurements, setProcurements] = useState([]);
    const [currentProcurement, setCurrentProcurement] = useState({
        title: "",
        description: ""
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            try {
                const data = await fetchStateProcurements();
                if (data.length > 0) {
                    setProcurements(data);
                    const firstItem = data[0];
                    setCurrentProcurement({
                        title: firstItem.title,
                        description: firstItem.description
                    });
                }
            } catch (error) {
                if (error.response?.status === 403) {
                    toast.error("Время сессии истекло, пожалуйста войдите заново", {
                        position: "bottom-left",
                        autoClose: 3000
                    });
                } else {
                    toast.error("Не удалось загрузить данные закупок", {
                        position: "bottom-left",
                        autoClose: 3000
                    });
                }
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, []);

    const handleSave = async () => {
        if (procurements.length === 0) return;

        setIsSubmitting(true);
        try {
            const updatedData = {
                title: currentProcurement.title.trim(),
                description: currentProcurement.description.trim()
            };

            await updateStateProcurement(procurements[0].id, updatedData);

            toast.success("Данные гос. закупок успешно обновлены", {
                position: "bottom-left",
                autoClose: 3000
            });

        } catch (error) {
            if (error.response?.status === 403) {
                toast.error("Время сессии истекло, пожалуйста войдите заново", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            } else {
                toast.error("Ошибка при обновлении данных", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };



    return (
        <div className="state-procurement-page">
            <Header />
            <ToastContainer />

            {isLoading ? (
                <div className="loader-wrapper">
                    <Loader />
                    <p className="loading-text">Загрузка данных...</p>
                </div>
            ) : (
                <div className="state-procurement-page_content">
                    <h2 className="section-title">Государственные закупки</h2>

                    <div className="form-wrapper">
                        <div className="form-group">
                            <label className="field-label">Описание раздела</label>
                            <TextareaAutosize
                                className="textarea-input white-field"
                                value={currentProcurement.description}
                                onChange={(e) => setCurrentProcurement(prev => ({
                                    ...prev,
                                    description: e.target.value
                                }))}
                                placeholder="Введите описание услуг"
                                minRows={3}
                            />
                        </div>

                        <button
                            className="no-form-save-button"
                            onClick={handleSave}
                            disabled={procurements.length === 0 || isSubmitting}
                        >
                            Сохранить изменения
                        </button>

                        {isSubmitting && (
                            <div className="loader-overlay">
                                <Loader />
                                <p>Сохранение изменений...</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default StateProcurementPage;